export class CAGroup {
    Id: number;
    Name: string;
    expanded?: boolean;
    WeeklySchedules: CAWeeklySchedule[];
    SpecialPlannings: CASpecialPlanning[];
    Position?: number;
}

export class CAGroupRequest {
    Id: number;
    Name: string;
    expanded?: boolean;
    WeeklySchedules: number[];
    SpecialPlannings: number[];
}


export class CAWeeklySchedule {
    Id?: number;
    Name: string;
    Weekdays: number;
    TimeFrom: string;
    TimeTo: string;
    WeekdaysList?: CAWeekDay[];
}

export class CASpecialPlanning {
    Id?: number;
    Name: string;
    DtFrom: string;
    DtTo: string;
    Access: boolean;
}

export class CAWeekDay {
    Value: string;
    Name: string;
    Enable: boolean;
}
